import { render, staticRenderFns } from "./modalities.vue?vue&type=template&id=59633d8f&scoped=true"
import script from "./modalities.vue?vue&type=script&lang=js"
export * from "./modalities.vue?vue&type=script&lang=js"
import style0 from "./modalities.vue?vue&type=style&index=0&id=59633d8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59633d8f",
  null
  
)

export default component.exports